import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { brandImage, headerLeftImage, HIDE_BUTTON_IMAGE } from '../../domain/countdown-bar.helpers';
import type { CountdownBarItem } from '../../store/countdown-bar.store';
import { CountdownBarTimeComponent } from '../countdown-bar-time/countdown-bar-time';

@Component({
  selector: 'bingo-countdown-bar-header',
  imports: [CountdownBarTimeComponent],
  templateUrl: './countdown-bar-header.html',
  styleUrl: './countdown-bar-header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'countdown-bar__header',
    '[class.is-hiding]': 'hiding()',
    '[class.is-unhiding]': 'unhiding()',
  },
})
export class CountdownBarHeaderComponent {
  protected readonly headerLeftImage = headerLeftImage;
  protected readonly brandImage = brandImage;
  protected readonly hideButtonImage = HIDE_BUTTON_IMAGE;
  readonly item = input.required<CountdownBarItem>();
  readonly collapsed = input(false);
  readonly hiding = input(false);
  readonly unhiding = input(false);
  readonly hide = output<Event>();
}
